import classNames from 'clsx';
import React from 'react';

import PokerLogo from '@swf/core/assets/pokerstars-logo-standalone.svg';

import styles from './Empty.scss';

export interface EmptySidecarProps {
  rootClass?: string;
}

const Empty: React.FC<EmptySidecarProps> = ({ rootClass }) => (
  <div className={classNames(styles.root, rootClass)} data-testid="sidecar empty">
    <PokerLogo />
  </div>
);

export default Empty;
